import React from 'react'
import { useIntl } from 'react-intl'
import { twMerge } from 'tailwind-merge'
import {
  PageActionPlaceHolder,
  CustomLinkComponent,
  DynamicTag,
  Spinner
} from 'msp-components'
import { useAccount } from 'msp-integrations'

import PaymentMethodDisplay from '@/components/molecules/PaymentMethodDisplay/PaymentMethodDisplay'

import translations from './AccountOverviewPaymentMethod.constants'
import * as S from './AccountOverviewPaymentMethod.styles'

export type AccountOverviewPaymentMethodProps = {
  className?: string
}

const AccountOverviewPaymentMethod = ({
  className = ''
}: AccountOverviewPaymentMethodProps) => {
  const { formatMessage } = useIntl()
  const {
    customer: { paymentInstruments = [], isInitialized }
  } = useAccount()
  const pageLink = '/account/payment-methods'

  return (
    <div className={twMerge(S.MainWrapper, className)}>
      <DynamicTag
        componentTagName='Headline'
        tag='h3'
        tagStyle='h6'
        className={S.Headline}
      >
        {formatMessage(translations.headline)}
      </DynamicTag>
      {!isInitialized && <Spinner />}
      {isInitialized && paymentInstruments.length === 0 && (
        <PageActionPlaceHolder
          text={formatMessage(translations.noPaymentMethods)}
        />
      )}
      {isInitialized && paymentInstruments.length > 0 && (
        <PaymentMethodDisplay paymentInstruments={paymentInstruments} />
      )}
      <CustomLinkComponent href={pageLink} className={S.Link}>
        {formatMessage(translations.headline)}
      </CustomLinkComponent>
    </div>
  )
}

export default AccountOverviewPaymentMethod
